import { render, staticRenderFns } from "./AdvancedSetting.vue?vue&type=template&id=be20fc50&scoped=true"
import script from "./AdvancedSetting.vue?vue&type=script&lang=js"
export * from "./AdvancedSetting.vue?vue&type=script&lang=js"
import style0 from "./AdvancedSetting.vue?vue&type=style&index=0&id=be20fc50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be20fc50",
  null
  
)

export default component.exports